export default __webpack_public_path__ + "static/media/icon_automation.6fac55ea.svg";